import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation"
import Table from "../../components/Table/Table";
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import { context, } from '../../context/authContext';
import useApi from '../../helpers/api';
import Loader from "../../components/Loader/Loader";
import useColumns from './columns';
import useActions from './acciones';
import ConfirmModal from "../../components/Modal/Modal.js"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';


export default function Roles() {
  const [data, setData] = useState(null);
  const [roles, setRoles] = useState(null);
  const { handleLogout, user } = useContext(context);
  const gridRef = useRef();
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const  columnDefs  = useColumns(setSelectedRow,setModalOpen);
  const { createHook, onCellEditingStopped, confirmDelete } = useActions();
  const api = useApi();

  const canCreate = useMemo(() => ({
    canCreate: Array.isArray(user?.rol) 
      ? user.rol.some(m => m.nombre === "Roles" && m.permiso.includes("crear")) 
      : false,
    button: "Añadir Permiso"
  }), [user?.rol]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getRolesPermisos();
        for(let rol of response){
          for(const permiso of rol.permiso){
            rol[permiso] = true;
          }
        }
        if (response?.response?.data?.error) {
          handleLogout();
          return;
        }
        setData(response)
        const getRoles = await api.getRoles();
        setRoles(getRoles)
      } catch (err) {
        handleLogout();
      }
    };

    fetchData();  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout]);

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Roles" />
      <Container className="mt-3">
        <Tabs
          defaultActiveKey={user.rol[0].rol === "superadmin" ? "superadmin" : user.rol[0].rol }
          id="uncontrolled-tab-example"
          className="mb-3"
        >
        {!!roles ? roles.map(rol=>
          rol.nombre === "superadmin" ?
            user.rol[0].rol === "superadmin" ? 
              <Tab key={rol.id} eventKey={rol.nombre} title={rol.nombre}>
                {!!data ? 
                  <Table 
                  columns={columnDefs} 
                  data={data.filter(data=>data.rol===rol.nombre)}
                  onCellEditingStopped={onCellEditingStopped}
                  canCreate={canCreate}
                  createHook={createHook}
                  gridRef={gridRef}
                  />
                :
                  <Loader/>
                }
              </Tab>
            :<></>
          : 
            <Tab key={rol.id} eventKey={rol.nombre} title={rol.nombre}>
              {!!data ? 
                <Table 
                columns={columnDefs} 
                data={data.filter(data=>data.rol===rol.nombre)}
                onCellEditingStopped={onCellEditingStopped}
                canCreate={canCreate}
                createHook={createHook}
                gridRef={gridRef}
                />
              :
                <Loader/>
              }
            </Tab>
        ) : <Loader/>}
        </Tabs>
      </Container>
      <ConfirmModal
        isOpen={modalOpen}
        message={`Are you sure you want to delete ${selectedRow?.data.nombre}?`}
        onConfirm={()=>confirmDelete(gridRef, selectedRow, setModalOpen, setSelectedRow)}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
}